/**
 * Portal Manta · ObrasConsolPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { ObrasConsolPorRodovia } from '../lotes-tabs/ObrasConsolPorRodovia.jsx';
import { MatrizDisciplinas } from '../lotes-vis/MatrizDisciplinas.jsx';
import { MatrizTiposObra } from '../lotes-vis/MatrizTiposObra.jsx';

const ObrasConsolPage = memo(function ObrasConsolPage_Inner({lote}){
  const [view,setView] = useState('rod');
  const subs = [
    {k:'rod',  l:'Por Rodovia (detalhe)',  sub:'Sidebar + retigráfico + 5 seções A-E'},
    {k:'mdisc',l:'Matriz Disciplinas',     sub:'Heatmap rodovias × disciplinas'},
    {k:'mtipo',l:'Matriz Tipos de Obra',   sub:'Heatmap rodovias × tipos (dup, faixa, OAE...)'},
  ];
  return(<div style={{display:'flex',flexDirection:'column',flex:1,overflow:'hidden'}}>
    <div style={{display:'flex',background:'#fff',borderBottom:'1px solid '+V.b1,padding:'0 14px',flexShrink:0,overflowX:'auto'}}>
      {subs.map(s=>{
        const ativo = s.k===view;
        return(<div key={s.k} onClick={()=>setView(s.k)} title={s.sub} style={{
          padding:'10px 16px',cursor:'pointer',whiteSpace:'nowrap',
          color:ativo?V.bl:V.gr,
          borderBottom:'2px solid '+(ativo?V.bl:'transparent'),
          fontSize:11.5,fontWeight:700
        }}>{s.l}</div>);
      })}
    </div>
    <div style={{flex:1,overflow:'auto'}}>
      {view==='rod'   && <ObrasConsolPorRodovia lote={lote}/>}
      {view==='mdisc' && <MatrizDisciplinas lote={lote}/>}
      {view==='mtipo' && <MatrizTiposObra lote={lote}/>}
    </div>
  </div>);
});

export { ObrasConsolPage };
export default ObrasConsolPage;
